const OrderSummary = () => import (/* webpackChunkName: "order-summary" */ './OrderSummary');

export default {
  path: '/order-summary',
  component: OrderSummary,
  name: 'orderSummary',
};